import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Halftone } from '../design/Paper';
import { Stamp } from '../design/Stamp';
import { tiltFor } from '../design/tokens';
import { ro } from '../i18n/ro';

/**
 * A vote opening is announced on the shared screen, because players are not
 * watching their phones. The overlay is decorative and pointer-transparent: it
 * never gates anything, and it clears itself.
 */
export function VoteOpening({ trigger }: { trigger: boolean }) {
  const [showing, setShowing] = useState(false);

  useEffect(() => {
    if (!trigger) return;
    setShowing(true);
    const timer = window.setTimeout(() => setShowing(false), 1_500);
    return () => window.clearTimeout(timer);
  }, [trigger]);

  return (
    <AnimatePresence>
      {showing && (
        <motion.div
          className="pointer-events-none absolute inset-0 z-40 flex items-center justify-center overflow-hidden bg-ink/85"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.4 } }}
          transition={{ duration: 0.12 }}
        >
          <Halftone className="text-paper opacity-25" />
          <div className="chevron-band absolute inset-x-0 top-0 h-[2.5cqh] text-paper opacity-40" />
          <div className="chevron-band absolute inset-x-0 bottom-0 h-[2.5cqh] text-paper opacity-40" />
          <motion.div
            initial={{ scale: 2.4, rotate: -7, opacity: 0 }}
            animate={{ scale: 1, rotate: 0, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 260, damping: 16 }}
          >
            <Stamp tone="teal" size="lg" className={`bg-paper ${tiltFor('opening')}`}>
              {ro.votingInProgress}
            </Stamp>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
